import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {useTheme} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {useDocument} from "@nandorojo/swr-firestore";
import React from "react";

import Props from "@sentrei/common/types/components/MemberMenu";

export default function MemberMenu({
  anchorEl,
  open,
  onClose,
  id,
  userId,
}: Props): JSX.Element {
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const {deleteDocument, loading} = useDocument(
    `spaces/${id}/members/${userId}`,
  );

  const handleClickOpen = (): void => {
    setDialogOpen(true);
  };

  const handleClickClose = (): void => {
    setDialogOpen(false);
  };

  const handleUnfollow = (): void => {
    deleteDocument()
      ?.then(() => {
        handleClickClose();
      })
      .catch(() => null);
  };

  return (
    <Menu
      id="member-menu"
      keepMounted
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
    >
      <MenuItem onClick={handleClickOpen}>
        <ListItem>
          <ListItemIcon>
            <ExitToAppIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Quit Space" />
        </ListItem>
      </MenuItem>
      <Dialog
        fullScreen={fullScreen}
        open={dialogOpen}
        onClose={onClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Are you sure you want to remove yourself from the group?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove your self from the group?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            disabled={loading}
            onClick={handleUnfollow}
            color="primary"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Menu>
  );
}
